var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs"},[_c('ul',[_c('router-link',{attrs:{"tag":"li","to":{ name: 'system-content-strings' },"active-class":"is-active"}},[_c('a',[_vm._v("Strings")])]),_vm._v(" "),_c('router-link',{attrs:{"tag":"li","to":{ name: 'system-content-links' },"active-class":"is-active"}},[_c('a',[_vm._v("Links")])])],1)]),_vm._v(" "),_c('div',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/content/index.vue?vue&type=template&id=324d1783
// module id = S9VU
// module chunks = 0